module.exports = __webpack_public_path__ + "img/angelov.466b6fce.jpg";